var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine2 = function SvgLine2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.967 14.229C51.57 33.412 48.331-9.375 88.515 4.444c26.184 9.004 26.381 15.797 26.381 15.797",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "1 9"
  })));
};
export default SvgLine2;